import {v4 as uuid} from "uuid";
import { displayDateText } from "@util/moment";
export const adaptPaymentChange = (raw = {}) => {
	const {
		title,
		applyDate,
		effectDate,
		employeeName,
		url,
	} = raw || {};

	const timelineSummary  = [{ label: "申請日期", text: displayDateText(applyDate) }];

	if (effectDate) {
		timelineSummary.push({ label: "生效日期", text: displayDateText(effectDate) });
	}

	if (employeeName) {
		timelineSummary.push({ label: "擔當", text: employeeName });
	}


	return (
		{
			id: uuid(),
			type: "payment",
			title,
			pdfUrl: url,

			// 卡片主內容說明區塊
			descList: null,

			// Timeline 上方額外顯示的 meta
			timelineMetainfo: timelineSummary
		}
	);
};
